module.exports = __webpack_public_path__ + "img/img_crm_phone.12c08099.svg";